import { render, staticRenderFns } from "./EnterpriseCard.vue?vue&type=template&id=2c1b895d&"
import script from "./EnterpriseCard.vue?vue&type=script&lang=js&"
export * from "./EnterpriseCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports